<div class="container">
  <div class="ssc-wrapper">
    <div class="ssc-list-content"  >
        <!-- top ad -->
        <div *ngIf="!loggedInIsGold" class="adsCenter">
          <ng-adsense 
          [adClient]="'ca-pub-4776037543768273'" 
          [adSlot]="9989671476" 
          [adFormat]="'horizontal'"
          ></ng-adsense></div>
      <div class="player-holder"  *ngIf="!loadingRecording; else skeleton">
        <div *ngIf='converting' id='conversionContainer'>
          <p>
            Congratulations! You're the first to play this recording on the new site. The page will refresh once it's ready.
          </p>
        </div>
        <app-recording-player
          *ngIf='recording'
          [rec]="recording"
          [showHeader]="false"
          [converting]='converting'
          (onLove)="onLoveHandle($event)"
          [volume]='volume'
        >
        </app-recording-player>
      </div>
      <div class="ql-editor-styles description" *ngIf='recording?.info'[innerHTML]="recording?.info | safeHtml"></div>
        <!-- top ad -->
        <div *ngIf="!loggedInIsGold" class="adsCenter">
          <ng-adsense 
          [adClient]="'ca-pub-4776037543768273'" 
          [adSlot]="9989671476" 
          [adFormat]="'horizontal'"
          ></ng-adsense></div>
              
      <div class="col-12 recording-body-details" *ngIf="recording?.allow_comments">
        <app-comments [comments]="comments" [commentsTotal]="commentsTotal" [recordingId]="recordingId">
        </app-comments>
      </div>
      <!-- top ad -->
      <div *ngIf="!loggedInIsGold" class="adsCenter">
        <ng-adsense 
        [adClient]="'ca-pub-4776037543768273'" 
        [adSlot]="9989671476" 
        [adFormat]="'horizontal'"
        ></ng-adsense></div>
          </div>

    <div class="ssc-sidebar" >
      <div class="recording-details">
        <div *ngIf="recording">
          <div class="recording-side-header">
            <div class="recording-users">
              <div class="recording-user" *ngFor="let user of recording.users">
                <img [src]="user.photo + '?h=100'"/>
                <app-user-online-icon [online]="user.online" size="xs"></app-user-online-icon> 
                <app-ss-user-name [user]="user"></app-ss-user-name>
              </div>
            </div>
            <div class="recording-icons">
              <app-icon-privacy-ic size="20" *ngIf="recording?.icons.ic"></app-icon-privacy-ic>
              <app-icon-privacy-memberonly size="20" *ngIf="recording?.members_only"></app-icon-privacy-memberonly>
              <app-icon-privacy-contest size="20" *ngIf="recording?.icons.contest"></app-icon-privacy-contest>
              <app-icon-privacy-private size="20" *ngIf="recording?.icons.private"></app-icon-privacy-private>
              <app-icon-privacy-public size="20" *ngIf="recording?.icons.public && !recording?.members_only"></app-icon-privacy-public>
            </div>
          </div>
          <div class="recording-artist">
            <div class="recording-artist-detail">
              <!-- can also use  tabindex="1"  to active keydown instead of contenteditable="true" -->
              <div class="recording-artist__title makeClickable" (click)="howOthersSingThis(recording?.song.id)" title="How Others Sing This">{{recording?.song.title}}</div>
              <div class="recording-artist__name makeClickable" (click)="navArtistProfile(recording?.song.artist.id)" title="Go to Artist Profile Page">{{recording?.song.artist.name}}</div>
            </div>
            <!-- <div class="ss-snap-credit-icon" (click)="openSnapModal()">
              <img src="/assets/pictures/ic_gold_snap.png" />
            </div> -->
            <div  class="rec-tags" [class.tags-pill]="pill" *ngIf="recording.badges != 0" [ngStyle]="getStyle(recording)" > {{ getRecordingTag(recording,100)}}  </div>
          </div>
          <div class="recording-remix" *ngIf="me && me.id === recording?.user.id">
            <div class="btn-remix" *ngIf='creationYear >= 2021' [routerLink]="['/remixer/', recording.id]">
              <i class="fa fa-repeat"></i>
              <span>Remix</span>
            </div>
            <div class="btn-remix" [routerLink]="['/d/my-recordings/', recording.id]">
              <app-icon-pencil color='#55dada'></app-icon-pencil>
              <span>Edit</span>
            </div>
          </div>

        </div>
        <div *ngIf="candidate" class="candidacy d-flex">
          <span>
            Accept or Reject Candidacy
          </span>
          <app-icon-button color="rgb(88, 199, 201)" size="30px" (click)="acceptCandidate(this.candidacyId)">
            <app-icon-check size="12" color="white"></app-icon-check>
          </app-icon-button>
          <app-icon-button color="transparent" [style.marginLeft]="'20px'" size="30px" (click)="rejectCandidate(this.candidacyId)">
            <app-icon-close size="16" color="rgb(180, 180, 180)"></app-icon-close>
          </app-icon-button>
        </div>

        

        <div class="box form-dropdown" *ngIf="this.recordingsLayers.items.length">
           <div ngbDropdown  #listDrop="ngbDropdown">
              <div
              class="btn form-dropdown-block lab" 
              id="dropdownLayers"
              ngbDropdownAnchor
              (click)="listDrop.toggle()"
              >View Layers
           </div> 
                <div ngbDropdownMenu aria-labelledby="dropdownLayers" >
                  <span> <button  class="wrapper" 
                    ngbDropdownItem
                    *ngFor="let item of this.recordingsLayers.items.slice().reverse(); let e = index" (click)="selectRecording(item)">
                        <span class="item-1"  >Layer {{this.recordingsLayers.items.length - e}}: </span>
                        <div class="item-2">
                        <app-ss-user-name  [user]="item.user" [showTrinkets]="false" [showStatus]= "false" [noLink] = "false" [disabled] = "true"></app-ss-user-name>
                        </div>
                        <div class="item-3">
                         <app-icon-time size="14" color="rgba(0, 0, 0, 0.4)" title="{{item?.created_at | dateFormat | date:'MMM d, yyyy h:mma' | dateAmpm}}"   > </app-icon-time>
                        </div>
                        <div class="item-4">
                         <div style="color: rgba(0, 0, 0, 0.4);">{{item?.created_at | dateFormat | date:'MMM d, yyyy h:mma' | dateAmpm}}</div>   
                        </div>
                        <div class="item-5">
                       <app-icon-button [shadow]="true" role="button" size="22px" color="#58c7c9"><app-icon-play color="white" size="20"></app-icon-play></app-icon-button> 
                      </div>
                  </button> </span>
                </div>

            </div>
        </div>


        <div class="recording-extra">
          <div class="recording-extra__time">
            <app-time-stamp [time]="recording?.created_at" [format]="'MMM dd, yyyy hh:mma'">
            </app-time-stamp>
          </div>
          <div class="recording-extra__stat fontStyle">
            <app-icon-comment color="#D0D0D0"></app-icon-comment>
            <div *ngIf="recording?.allow_comments; else track_comments_na">{{formatComments(commentsTotal)}}</div>
            <ng-template #track_comments_na> </ng-template>
          </div>
          <div class="recording-extra__stat fontStyle">
            <app-icon-eye size="24" color="#D0D0D0"></app-icon-eye>
            <div *ngIf="recording?.track_views; else track_views_na" >{{formatViews(viewsTotal)}}</div>
            <ng-template #track_views_na> </ng-template>
          </div>
        </div>
        <div class="recording-reactions">
          <div class="recording-reactions__emoji">
            <app-reaction #listenReaction [reactionList]="reactionList" [reactions]="reactions"></app-reaction>
          </div>
          <div class="recording-reactions__love fontStyle">
            <svg xmlns="http://www.w3.org/2000/svg" id="gift" width="17.737" height="16.581" viewBox="0 0 17.737 16.581">
              <path id="Path_169" data-name="Path 169" d="M6.141,5.684,4.66,7.5l.328.216L6.5,5.684ZM6.433,2.19a.872.872,0,1,0,.887.871A.879.879,0,0,0,6.433,2.19ZM2,14.03V15.3H8.207V14.03ZM11.753,2.19a.879.879,0,0,0-.887.871.891.891,0,0,0,1.773,0A.879.879,0,0,0,11.753,2.19Zm.293,3.494h-.364L13.2,7.714l.328-.216ZM9.98,14.03V15.3h6.207V14.03Zm0,0V15.3h6.207V14.03Zm2.066-8.347h-.364L13.2,7.714l.328-.216ZM11.753,2.19a.879.879,0,0,0-.887.871.891.891,0,0,0,1.773,0A.879.879,0,0,0,11.753,2.19ZM2,14.03V15.3H8.207V14.03ZM6.433,2.19a.872.872,0,1,0,.887.871A.879.879,0,0,0,6.433,2.19ZM6.141,5.684,4.66,7.5l.328.216L6.5,5.684Zm0,0L4.66,7.5l.328.216L6.5,5.684ZM6.433,2.19a.872.872,0,1,0,.887.871A.879.879,0,0,0,6.433,2.19ZM2,14.03V15.3H8.207V14.03ZM11.753,2.19a.879.879,0,0,0-.887.871.891.891,0,0,0,1.773,0A.879.879,0,0,0,11.753,2.19Zm.293,3.494h-.364L13.2,7.714l.328-.216ZM9.98,14.03V15.3h6.207V14.03Zm0,0V15.3h6.207V14.03Zm2.066-8.347h-.364L13.2,7.714l.328-.216ZM11.753,2.19a.879.879,0,0,0-.887.871.891.891,0,0,0,1.773,0A.879.879,0,0,0,11.753,2.19ZM2,14.03V15.3H8.207V14.03ZM6.433,2.19a.872.872,0,1,0,.887.871A.879.879,0,0,0,6.433,2.19ZM6.141,5.684,4.66,7.5l.328.216L6.5,5.684Zm0,0L4.66,7.5l.328.216L6.5,5.684ZM6.433,2.19a.872.872,0,1,0,.887.871A.879.879,0,0,0,6.433,2.19ZM2,14.03V15.3H8.207V14.03ZM11.753,2.19a.879.879,0,0,0-.887.871.891.891,0,0,0,1.773,0A.879.879,0,0,0,11.753,2.19Zm.293,3.494h-.364L13.2,7.714l.328-.216ZM9.98,14.03V15.3h6.207V14.03Zm0,0V15.3h6.207V14.03Zm1.7-8.347L13.2,7.714l.328-.216L12.046,5.684Zm.071-1.751a.879.879,0,0,0,.887-.871.891.891,0,0,0-1.773,0,.879.879,0,0,0,.887.871ZM2,15.3H8.207V14.03H2ZM6.433,3.933a.872.872,0,1,0-.887-.871A.879.879,0,0,0,6.433,3.933ZM6.5,5.684H6.141L4.66,7.5l.328.216ZM9.98,14.03V15.3h6.207V14.03Zm1.7-8.347L13.2,7.714l.328-.216L12.046,5.684Zm.071-1.751a.879.879,0,0,0,.887-.871.891.891,0,0,0-1.773,0,.879.879,0,0,0,.887.871ZM2,15.3H8.207V14.03H2ZM6.433,3.933a.872.872,0,1,0-.887-.871A.879.879,0,0,0,6.433,3.933ZM6.5,5.684H6.141L4.66,7.5l.328.216Zm-.364,0L4.66,7.5l.328.216L6.5,5.684ZM6.433,2.19a.872.872,0,1,0,.887.871A.879.879,0,0,0,6.433,2.19ZM2,14.03V15.3H8.207V14.03ZM11.753,2.19a.879.879,0,0,0-.887.871.891.891,0,0,0,1.773,0A.879.879,0,0,0,11.753,2.19Zm.293,3.494h-.364L13.2,7.714l.328-.216ZM9.98,14.03V15.3h6.207V14.03Zm0,0V15.3h6.207V14.03Zm2.066-8.347h-.364L13.2,7.714l.328-.216ZM11.753,2.19a.879.879,0,0,0-.887.871.891.891,0,0,0,1.773,0A.879.879,0,0,0,11.753,2.19ZM2,14.03V15.3H8.207V14.03ZM6.433,2.19a.872.872,0,1,0,.887.871A.879.879,0,0,0,6.433,2.19ZM6.141,5.684,4.66,7.5l.328.216L6.5,5.684Zm0,0L4.66,7.5l.328.216L6.5,5.684ZM6.433,2.19a.872.872,0,1,0,.887.871A.879.879,0,0,0,6.433,2.19ZM2,14.03V15.3H8.207V14.03ZM11.753,2.19a.879.879,0,0,0-.887.871.891.891,0,0,0,1.773,0A.879.879,0,0,0,11.753,2.19Zm.293,3.494h-.364L13.2,7.714l.328-.216ZM9.98,14.03V15.3h6.207V14.03Zm0,0V15.3h6.207V14.03Zm2.066-8.347h-.364L13.2,7.714l.328-.216ZM11.753,2.19a.879.879,0,0,0-.887.871.891.891,0,0,0,1.773,0A.879.879,0,0,0,11.753,2.19ZM2,14.03V15.3H8.207V14.03ZM6.433,2.19a.872.872,0,1,0,.887.871A.879.879,0,0,0,6.433,2.19ZM6.141,5.684,4.66,7.5l.328.216L6.5,5.684Z" transform="translate(-0.225 -0.439)" fill="none"/>
              <path id="Path_170" data-name="Path 170" d="M6.436,9.35l-1.108-.72L5,9.071l1.436,1.023,2.11-2.83v-.5Zm7.093-.72-1.108.72-2.1-2.59v.5l2.11,2.83,1.436-1.023Z" transform="translate(-0.564 -1.355)" fill="#c8c8c8"/>
              <path id="Path_171" data-name="Path 171" d="M15.959,3.494H14.026a2.593,2.593,0,0,0,.16-.871A2.637,2.637,0,0,0,11.526,0,2.664,2.664,0,0,0,9.31,1.183l-.443.584-.443-.592A2.721,2.721,0,0,0,6.206,0a2.637,2.637,0,0,0-2.66,2.622,2.593,2.593,0,0,0,.16.871H1.773a1.943,1.943,0,0,0-1.291.543A1.577,1.577,0,0,0,0,5.245v9.594a1.578,1.578,0,0,0,.486,1.2,1.943,1.943,0,0,0,1.287.54H15.959a1.943,1.943,0,0,0,1.287-.54,1.578,1.578,0,0,0,.486-1.2V5.245A1.758,1.758,0,0,0,15.959,3.494ZM6.206,1.751a.872.872,0,1,1-.887.871A.879.879,0,0,1,6.206,1.751ZM7.98,14.862H1.773V10.585H7.98Zm0-5.868H1.773V5.245h4.5L4.761,7.275l1.108.72L7.98,5.4Zm3.547-7.243a.879.879,0,0,1,.887.871.891.891,0,0,1-1.773,0,.879.879,0,0,1,.887-.871Zm4.433,13.112H9.753V10.585h6.207Zm0-5.868H9.753V5.4l2.11,2.59,1.108-.72L11.455,5.245h4.5Z" transform="translate(0.002)" fill="#c8c8c8"/>
            </svg>
            <p style="margin: 0 0.7rem 0 0.3rem;">{{rosesCount}}</p>
          </div>
          <div class="recording-reactions__love fontStyle"> 
            <app-icon-heart class="btn-heart"  (click)="toggleLove()" color="#D0D0D0" ></app-icon-heart>
            <div *ngIf="recording?.allow_loves; else track_loves_na">{{formatLove(recording?.stats?.love)}}</div>
            <ng-template #track_loves_na> </ng-template>
          </div>
        </div>
        <div class="recording-share">
          <div class="recording-share-item" ngbDropdown>
            <app-icon-plus color="#D0D0D0"></app-icon-plus>
            <span ngbDropdownToggle>ADD TO ...</span>
            <div class="ssc-title-options" ngbDropdownMenu>
              <div class="dropdown-orderby">
                <div class="dropdown-menu-content">
                 
                  <div *ngIf="!recording?.favorited" (click)="favRecording(recording)">Add Recording to Favorites</div>
                  <div *ngIf="recording?.favorited" (click)="unFavRecording(recording)">Remove Recording from Favorites</div>
                  <div *ngIf="!recording?.user.favorited" (click)="favUser(recording?.user)">Add Member to Favorites</div>
                  <div *ngIf="recording?.user.favorited" (click)="unfavUser(recording?.user)">Remove Member from Favorites</div>
                  <div *ngIf="!recording?.user.notified && profileService.userId != recording?.user.id" (click)="subscribeUser(recording)">Notify Me Next Time User Sings</div>
                  <div *ngIf="recording?.user.notified" (click)="unsubscribeUser(recording)">Unsubscribe from User</div>
                  <div *ngIf="!recording?.song.favorited" (click)="favSong(recording.song)">Add Song to Favorites</div>
                  <div *ngIf="recording?.song.favorited" (click)="unFavSong(recording.song)">Remove Song from Favorites</div>
                  <div (click)="onAddtoPlaylist()">Add to Playlist</div>
                </div>
              </div>
            </div>
          </div>
          <div class="recording-share-item" (click)="handleSing(recording.song)">
            <app-icon-mic color="#D0D0D0" size="14"></app-icon-mic>
            <span>SING</span>
          </div>
          <div class="recording-share-item " [ngClass]="recording?.allow_share == false || recording?.private == true ? 'disable' : ''" (click)='shareRecording(recording)'>
            <app-icon-share color="#D0D0D0"></app-icon-share>
            <span>SHARE</span>
          </div>
          <!-- If duets are allowed -->
          <div *ngIf="allowDuets" class="recording-share-item"  (click)="handleDuet(recording)" >
            <app-icon-duet color="#D0D0D0"></app-icon-duet>
            <span>DUET / JAM</span>
          </div>
          <!-- If duets aren't allowed -->
          <div *ngIf="!allowDuets" class="recording-share-item" style="color: #c5c5c5; cursor:default">
          <app-icon-duet color="#D0D0D0"></app-icon-duet>
            <span>DUET / JAM</span>
          </div>
          <div class="recording-share-item" (click)="onReport()">
            <app-icon-warning color="#D0D0D0"></app-icon-warning>
            <span>REPORT</span>
          </div>
          <div class="recording-share-item" (click)="sendGift()">
            <app-icon-atm color="#D0D0D0"></app-icon-atm>
            <span>SEND A GIFT</span>
          </div>
          <hr style="width:100%; color:rgba(0, 0, 0, 0.1); margin-top:0rem; margin-bottom:0.5rem">
          <button *ngIf="profileService.userId != recording?.user.id" class="SnapATip" (click)="sendSnap()"> 
          <img class="snapIcon" width="18px"src="/assets/pictures/ic_gold_snap.png" />Snap a Tip!</button> 

          <button *ngIf="recording?.private == false && recording?.members_only == false && recording?.allow_share == true" class="ShowcaseFeature" (click)="openShowcaseModal(recording)"> 
         Showcase This Recording</button> 
        
        </div>
      </div>
      <app-add-to-playlist #playlist></app-add-to-playlist>
      
      <app-ss-featured-list
        type="recording"
        title="Watch Next"
        [data]="recordings"
        (loadMore)="loadRecordings()"    
        *ngIf="!loadingRecording"
      >
        <ng-template #itemContent let-item>
          <div class="ssc-list-item">
            <app-ss-recording  (click)="onPlayRecording(item)" [recording]="item"></app-ss-recording>
            <div class="song-actions">
              <a title="Play" (click)="onPlayRecording(item)"></a>
              <!-- <app-icon-button (click)="onPlayRecording(item)" size="40px" color="#58c7c9">
                <app-icon-play color="white"></app-icon-play>
              </app-icon-button> -->
              <app-more-dot-menu>
                <div class="dropdown-menu-content">
                  <div *ngIf="item.private == false && item.members_only == false" (click)="openShowcaseModal(item)">Showcase This Recording</div>
                  <div *ngIf="!item?.favorited" (click)="favRecording(item)">Add Recording to Favorites</div>
                  <div *ngIf="item?.favorited" (click)="unFavRecording(item)">Remove Recording from Favorites</div>
                  <div *ngIf="!item.users[0].notified && profileService.userId != item.user_id" (click)="subscribeUser(item)">Notify Me Next Time User Sings</div>
                  <div *ngIf="item.users[0].notified" (click)="unsubscribeUser(item)">Unsubscribe from User</div>
                  <div (click)="shareRecording(item)">Share this recording</div>
                  <div (click)="onAddtoPlaylist(item.id)">Add to Playlist</div>
                  <div (click)="howOthersSingThis(item.song.id)">How Others Sing This</div>
                </div>
              </app-more-dot-menu>
            </div>
          </div>
          <app-recording-stat [recording]="item"></app-recording-stat>
        </ng-template>
      </app-ss-featured-list>
    </div>
  </div>
  <app-ss-report-modal #report (report)="reportRecording($event)" [reporting]="reporting">
    <div class="report-content">
      <!-- <app-ss-recording *ngIf="recording" [recording]="recording"></app-ss-recording> -->
    </div>
  </app-ss-report-modal>
  <app-purchase-gold-modal #goldcontent type="2"></app-purchase-gold-modal>
  <app-blocked-notify-modal #blockedModal (closed)="handleBlockedClosed()"></app-blocked-notify-modal>
  <app-snap-credit-modal #snap></app-snap-credit-modal>
  <app-showcase-modal #showcase recordingTitle='' [recordingObject]="recordingToShowcaseModalBox"></app-showcase-modal>
</div>


<ng-template #skeleton>
  <div class="skeleton-player-holder skeleton-color"></div>
</ng-template>



<ng-template #skeletonSideBar>
  <div class="skeleton-ssc-sidebar">
    <div class="recording-details">
      <div class="recording-side-header">
        <div class="recording-users">
          <div class="recording-user">
            <div class="skeleton-img-round skeleton-color"></div>
            <div class="skeleton-usersname skeleton-color"></div>
            <div class="skeleton-img-round-small skeleton-color"></div>
          </div>
          <div class="recording-artist">
            <div class="recording-artist-detail">
              <div class="skeleton-title skeleton-color"></div>
              <div class="skeleton-artist skeleton-color"></div>
            </div>
          </div>
          <div class="recording-extra">
            <div class="skeleton-date skeleton-color"></div>
            <div class="skeleton-block skeleton-color"></div> 
          </div>
          <div class="recording-reactions">
            <div class="skeleton-img-round skeleton-color"></div>
            <div class="skeleton-smallBlock skeleton-color"></div>
          </div>
          <div class="recording-share">
            <div class="recording-share-item" ngbDropdown>
              <app-icon-plus color="#D0D0D0"></app-icon-plus>
              <span ><div class="skeleton-text skeleton-color"></div></span>
              <div class="ssc-title-options" ngbDropdownMenu>
              </div>
            </div>
            <div class="recording-share-item">
              <app-icon-mic color="#D0D0D0" size="14"></app-icon-mic>
              <span ><div class="skeleton-text skeleton-color"></div></span>
            </div>
            <div class="recording-share-item " [ngClass]="''" >
              <app-icon-share color="#D0D0D0"></app-icon-share>
              <span ><div class="skeleton-text skeleton-color"></div></span>
            </div>
            <div class="recording-share-item" >
              <app-icon-duet color="#D0D0D0"></app-icon-duet>
              <span ><div class="skeleton-text skeleton-color"></div></span>
            </div>
            <div class="recording-share-item">
              <app-icon-warning color="#D0D0D0"></app-icon-warning>
              <span ><div class="skeleton-text skeleton-color"></div></span>
            </div>
            <div class="recording-share-item">
              <app-icon-atm color="#D0D0D0"></app-icon-atm>
              <span ><div class="skeleton-text skeleton-color"></div></span>
            </div>
            <hr style="width:100%; color:rgba(0, 0, 0, 0.1); margin-top:0rem; margin-bottom:0.5rem">
            <div class="skeleton-snapATip skeleton-color"></div>
            <hr style="width:100%; color:rgba(0, 0, 0, 0.1); margin-top:0rem; margin-bottom:0.5rem">
          </div>
        </div>
      </div>
     </div>
    </div>
</ng-template>


